import { Flex, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  colorBgSucessBold,
  colorBgSuccessHovered,
  colorBgErrorBold,
  colorBgErrorHovered,
} from 'src/app/themes/primaryThemeDefault'
import { GreyDotIcon, GreenDotIcon, RedDotIcon } from 'src/assets/icons'

interface PropsTag {
  status: 'Failed' | 'Sent'
}

export const StatusTag: React.FC<PropsTag> = React.memo(({ status }) => {
  const { t } = useTranslation()

  const getTag = (): { value: string; color: string; bgColor: string; dot: React.ReactElement } => {
    switch (status) {
      case 'Failed':
        return {
          value: t(`SentEmailLog:sentEmailResults.tags.failed`),
          color: colorBgErrorBold,
          bgColor: colorBgErrorHovered,
          dot: <RedDotIcon style={{ color: 'red' }} />,
        }

      default:
        // default return value sent
        return {
          value: t(`SentEmailLog:sentEmailResults.tags.sent`),
          color: colorBgSucessBold,
          bgColor: colorBgSuccessHovered,
          dot: <GreenDotIcon />,
        }
    }
  }

  return (
    <Flex
      align='center'
      justify='center'
      gap={4}
      style={{
        backgroundColor: getTag()?.bgColor,
        borderRadius: '27px',
        padding: ' 4px 10px',
        width: '77px',
      }}
    >
      {getTag()?.dot}
      <Typography.Text style={{ color: getTag()?.color, fontSize: '14px', fontWeight: 700 }}>
        {getTag()?.value}
      </Typography.Text>
    </Flex>
  )
})
